<template>
<m-pageframe
    :title="title"
>
<v-container
    v-if="start_data != null"
>
    

   <v-stepper 
        v-model="stage" 
        vertical
    >
        <v-stepper-step 
            step="1" 
            :complete="stage > 1"
        >
            Add Note to Customer Profile
        </v-stepper-step>

        <v-stepper-content step="1">
            <p>A specially formatted note including all text, files and payments in the conversation to date will be placed on your clipboard for easy pasting into a note in the Client Profile.</p>
            <p>If you have previously sent this conversation to your CRM, only new messages will be placed in the note</p>
             <v-btn
                v-on:click="onCancel"
                style="margin-right: 15px;"
            >
                Cancel
            </v-btn>

            <v-btn
                color="primary"
                v-on:click="copyConversation"
            >
                Copy Conversation
            </v-btn>
            
            <code v-if="show_copy_conversation" style="display: block; white-space: pre;">
            <span ref="copy_src">{{this.start_data.full_conversation_text}}</span>
            </code>
           
        </v-stepper-content>

        <v-stepper-step 
            step="2" 
            :complete="stage > 2"
        >
            Record in Conversation
        </v-stepper-step>

        <v-stepper-content step="2">
            <p>Once you've added this note to your CRM, click the button below to update your conversation.</p>
            <p>The customer will not receive a message, but you and other RedChirp users will see that you have sent this conversation to your CRM at this specific date and time.</p>
            
             <v-btn
                v-on:click="onCancel"
                style="margin-right: 15px;"
            >
                Cancel
            </v-btn>
            
            <v-btn
                color="primary"
                v-on:click="onRecord"
            >
                Record
            </v-btn>
            
        </v-stepper-content>

   </v-stepper>


</v-container>
</m-pageframe>
</template>

<script>


export default {
    data() {
        return {
            start_data: null,
            stage: 1,
            show_copy_conversation: false,
        }
    },

    mounted () {
        
        let params = {
            'integration_id' : this.$route.params.integration_id,
            'conversation_id' : this.$route.params.conversation_id,
            'active_endpoint' : this.$route.params.active_endpoint,
        };

        this.$rc.showSpinner();
        this.$rc.getAdfStartData(
            params,
        
            (start_data) => {
                this.$rc.hideSpinner();

                this.start_data = start_data;
            },
        
            () => {
                this.$rc.hideSpinner();
                this.$rc.alert('Error','Unable to complete API call');
            },
        );
    },

    methods: {
        onCancel() 
        {
            let params = {
                'conversation_id' : this.$route.params.conversation_id,
                'endpoint' : this.$route.params.active_endpoint,
            };

            this.$router.push({
                'name': 'home-routed',
                'params' : params,
            }).catch(e=>{}); // swallow any exception
        },

        copyConversation()
        {
            this.show_copy_conversation = true;

            window.setTimeout(
                () => {
                    let code_span = this.$refs['copy_src'];

                    var range = document.createRange();
                    range.selectNode(code_span);
                    window.getSelection().removeAllRanges(); // clear current selection
                    window.getSelection().addRange(range); // to select text
                    document.execCommand("copy");
                    window.getSelection().removeAllRanges();// to deselect

                    this.$rc.snackbar('Conversation copied.',1000);

                    this.stage = 2;
                },
                100
            )

            /* This is better code that uses the clipboard API... but, sadly, does not work iOS
            this.$rc.snackbar('Conversation copied');
            navigator.clipboard.writeText(this.start_data.full_conversation_text)
            .then(() => {
                this.stage = 2;
            })
            .catch(err => {
                this.$rc.alert('Error','Unable to copy note to clipboard.');
            });*/
        },

        onRecord()
        {
            let params = {
               'integration_id' : this.start_data.integration_id,
               'conversation_id' : this.$route.params.conversation_id,
               'active_endpoint' : this.$route.params.active_endpoint,
           };

           this.$rc.showSpinner();
           this.$rc.recordAdfAddNote(
               params,
           
               (data) => {
                   this.$rc.hideSpinner();
                   this.onCancel();
               },
           
               () => {
                   this.$rc.hideSpinner();
                   this.$rc.alert('Error','Unable to record note.');
               },
           );
        },

        onSend()
        {
           this.onCancel();
       },

    },

    computed: {
        title() {
            if ( this.start_data != null && this.start_data.contact_full_name != null && this.start_data.contact_full_name.trim().length > 0 )
            {
                return 'Add note to customer profile: '+this.start_data.contact_full_name.trim();
            }

            return 'Add Note to Customer Profile';
        }
    },
}
</script>

<style lang="scss" scoped>
</style>

